const FAILED_STATUSES = new Set(["failed", "undelivered"]);

export function normalizeReminderDeliveryStatus(status) {
  const normalized = String(status || "").trim().toLowerCase();

  if (normalized === "read") return "read";
  if (normalized === "delivered" || normalized === "received") return "received";
  if (normalized === "sent") return "sent";
  if (FAILED_STATUSES.has(normalized)) return "failed";

  return "pending";
}

export function getReminderDeliveryLabel(status) {
  switch (normalizeReminderDeliveryStatus(status)) {
    case "read":
      return "Read";
    case "received":
      return "Received";
    case "sent":
      return "Sent";
    case "failed":
      return "Failed";
    default:
      return "Pending";
  }
}

export function isReminderDeliveryFailure(status) {
  return normalizeReminderDeliveryStatus(status) === "failed";
}

export function normalizeReminderPhone(value) {
  return String(value || "")
    .replace(/^whatsapp:/i, "")
    .replace(/\D+/g, "");
}

function newestFirst(left, right) {
  const leftTime = Date.parse(left?.sent_at || "") || 0;
  const rightTime = Date.parse(right?.sent_at || "") || 0;
  return rightTime - leftTime;
}

export function findLatestReminderLogForRow(row, logs) {
  if (!row || !Array.isArray(logs)) return null;

  const appointmentId = String(row.appointment_id || "").trim();
  if (appointmentId) {
    const byAppointment = logs
      .filter((log) => String(log?.appointment_id || "").trim() === appointmentId)
      .sort(newestFirst);
    if (byAppointment.length > 0) return byAppointment[0];
  }

  const rowPhone = normalizeReminderPhone(row.phone);
  if (!rowPhone) return null;

  const byPhone = logs
    .filter((log) => normalizeReminderPhone(log?.patient_num) === rowPhone)
    .sort(newestFirst);

  return byPhone[0] || null;
}

export function mergeReminderLogDeliveryUpdate(logs, conversation) {
  if (!Array.isArray(logs)) return logs;

  const messageSid = String(conversation?.message_sid || "").trim();
  if (!messageSid) return logs;

  let changed = false;
  const nextLogs = logs.map((log) => {
    if (String(log?.message_sid || "").trim() !== messageSid) {
      return log;
    }

    const nextLog = { ...log };
    for (const field of ["delivery_status", "delivered_at", "read_at"]) {
      if (
        Object.prototype.hasOwnProperty.call(conversation, field) &&
        nextLog[field] !== conversation[field]
      ) {
        nextLog[field] = conversation[field];
        changed = true;
      }
    }
    return nextLog;
  });

  return changed ? nextLogs : logs;
}
